/**
 * JSON do ambiente do portal na tela da configuracao de plataforma (R5-M23).
 *
 * O servidor guarda o texto exato que recebeu, na forma compacta, e devolve esse texto
 * em `portal_environment_text`. A tela nao passa o valor por `JSON.parse` e
 * `JSON.stringify`: isso perde precisao acima de 2^53, reordena chaves numericas, troca
 * `1.0` por `1` e muda escapes, e salvar so um interruptor regravaria o JSON diferente.
 *
 * Por isso a tela so acrescenta espaco e quebra de linha fora das aspas, para leitura,
 * e envia o texto como texto. O servidor compacta de novo, tirando so esse espaco, e o
 * JSON que nao mudou volta igual, byte a byte.
 */

/**
 * Indenta o JSON compacto sem tocar em nenhum valor: so acrescenta espaco e quebra de
 * linha fora das aspas. Texto que nao e JSON compacto volta como veio.
 */
export function indentarJson(texto: string, recuo = '  '): string {
  let saida = '';
  let nivel = 0;
  let emTexto = false;
  let escapado = false;
  const quebra = () => `\n${recuo.repeat(nivel)}`;

  for (let i = 0; i < texto.length; i += 1) {
    const c = texto[i]!;
    if (emTexto) {
      saida += c;
      if (escapado) escapado = false;
      else if (c === '\\') escapado = true;
      else if (c === '"') emTexto = false;
      continue;
    }
    if (c === ' ' || c === '\n' || c === '\r' || c === '\t') {
      // O texto ja tinha espaco: nao e o compacto do servidor. Devolve como veio.
      return texto;
    }
    switch (c) {
      case '"':
        emTexto = true;
        saida += c;
        break;
      case '{':
      case '[': {
        const fecha = c === '{' ? '}' : ']';
        if (texto[i + 1] === fecha) {
          // Objeto ou lista vazia fica numa linha so.
          saida += c + fecha;
          i += 1;
          break;
        }
        nivel += 1;
        saida += c + quebra();
        break;
      }
      case '}':
      case ']':
        nivel = Math.max(0, nivel - 1);
        saida += quebra() + c;
        break;
      case ',':
        saida += c + quebra();
        break;
      case ':':
        saida += ': ';
        break;
      default:
        saida += c;
    }
  }
  return saida;
}
